import { useTranslations } from "../../hooks/useTranslations";
import DepartmentApps from "../DepartmentApps";
import Page from "../ui/Page";
import PageSection from "../ui/PageSection";

const WebMarketing = () => {
  const { i18n } = useTranslations();
  return (
    <Page
      title={i18n.departments.webMarketing.title}
      description={i18n.departments.webMarketing.description(
        <a href="https://booking.hgv.it/de" target="_blank">
          {i18n.departments.webMarketing.descriptionLinkLabel}
        </a>,
      )}
    >
      <PageSection title={i18n.nav.apps}>
        <DepartmentApps department="webMarketing" />
      </PageSection>
    </Page>
  );
};

export default WebMarketing;
